import { Box, styled } from '@mui/material';

export const SingleIncrementInfoStyled = styled(Box)({
  backgroundColor: '#fbfbfb',
  borderRadius: '4px',
  border: 'solid #e6e6e6 1px',
  height: '100%',
  width: '100%',
  '@media (min-width: 1199px)': {
    marginLeft: '42px',
    marginRight: '42px',
  },
});
